import React from 'react';
import { inject, observer } from 'mobx-react';
import H5PhotographyList from './h5';
import PCPhotographyList from './pc';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { withRouter, RouteComponentProps } from 'react-router-dom';

interface PhotographyListProps extends RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    data?: any;
    type?:   any;   // 类型 1：正常作品列表 2：我的作品
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    emptyText?: string; // 为空时提示文字
    emptyIcon?: string; // 为空时icon
    emptyBoxStyle?: any; // 为空状态时的自定义样式
    searchKeyword?: any
    voteClick?: Function;
    canvassForVotesClick?: Function;    // 拉票
    isShowTopThree?: boolean    // 是否展示前三名特殊样式
    showVideoIcon?: boolean; // 是否展示视频标识，默认展示
    showWorkRanking?: boolean; // 展示作品实际排名，而非列表序号
    photographyDetail?: any // 摄影大赛详情
    currentItemClick?: Function;   // 点击打开详情
}

@inject('app', 'site', 'user')
@observer
class PhotographyList extends React.Component<PhotographyListProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
        // console.log('组件组件');
    }

    render() {
        const { site, app, data, searchKeyword,loading, hasMore, onLoadMore, voteClick, canvassForVotesClick, isShowTopThree, currentItemClick, photographyDetail, ...props } = this.props;
        const platform = app?.platform || 'h5';
         // 确保传递 data 属性，即使为空数组
        const postListData = data || [];
        // console.log(postListData, platform, '组件入口')
        if (platform === 'pc') {
            return <PCPhotographyList {...props} searchKeyword={searchKeyword} data={postListData} loading={loading}
            hasMore={hasMore}
            onLoadMore={onLoadMore || (() => { })}/>;
        } else {
            return <H5PhotographyList {...props} data={postListData} voteClick={voteClick} currentItemClick={currentItemClick} canvassForVotesClick={canvassForVotesClick} searchKeyword={searchKeyword} photographyDetail={photographyDetail} isShowTopThree={isShowTopThree} loading={loading}
            hasMore={hasMore}
            onLoadMore={onLoadMore || (() => { })} />;
        }
    }
}

export default withRouter(PhotographyList);
